<template>
  <div>
    <!-- <input type="text" id="txtCaptcha" value readonly class="captchaInput" /> -->

    <div style="position:relative;">
      <div id="txtCaptcha" class="captchaInput"></div>

      <button name="btnRefresh" class="captchaButton" oncopy="return false;" onpaste="return false;" oncut="return false;" @click.prevent="generateCaptcha()">
        <a href="#">REFRESH</a>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    generateCaptcha() {
      var randomCaptcha =
        "1234567890@!#$&*ABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$&*abcdefghijklmnopqrstuvwxyz";
      var element = document.getElementById("txtCaptcha");
      element.innerHTML = "";
      var x = randomCaptcha[Math.floor(Math.random() * randomCaptcha.length)];
      for (var i = 0; i < 6; i++) {
        x = x + randomCaptcha[Math.floor(Math.random() * randomCaptcha.length)];
      }
      element.innerHTML +=
        '<span style="color:#bd290f;text-shadow:0 0 3px #f50a4c;font-family: cursive;padding-right:4px">' +
        x.substring(0, 1) +
        "</span>";
      element.innerHTML +=
        `<span style="color:#378ce6;text-shadow:0 0 6px #378ce6;
        font-family: monospace;padding-right:8px;-webkit-transform: rotate(-90deg)
        ;-moz-transform: rotate(-90deg);-ms-transform: rotate(-90deg);-o-transform: rotate(-90deg);
        filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);text-decoration: line-through;">` +
        x.substring(1, 2) +
        "</span>";
      element.innerHTML +=
        '<span style="color:#37dbb8;text-shadow:0 0 20px #37dbb8;font-family: fantasy;padding-right:2px;text-decoration: line-through;">' +
        x.substring(2, 3) +
        "</span>";
      element.innerHTML +=
        '<span style="color:#86e637;text-shadow:0 0 10px #f9f7fa;font-family: sans-serif;padding-right:4px;text-decoration: line-through;">' +
        x.substring(3, 4) +
        "</span>";
      element.innerHTML +=
        '<span style="color:#e637d2;text-shadow:0 2px 12px #f2f279;font-family: ui-monospace;padding-right:5px;text-decoration: line-through;">' +
        x.substring(4, 5) +
        "</span>";
      element.innerHTML +=
        '<span style="color:#f5bc42;text-shadow:0 0 15px #f5bc42;font-family: sans-serif;padding-right:1px;text-decoration: line-through;">' +
        x.substring(5, 6) +
        "</span>";
      element.innerHTML +=
        '<span style="color:#f55742;;text-shadow:0 0 30px #f5bc42;font-family: cursive;;padding-right:2px;text-decoration: line-through;">' +
        x.substring(6, 7) +
        "</span>";
      // var element = document.getElementById("txtCaptcha");
      //element.value = x;
    }
  },

  mounted() {
    window.onload = this.generateCaptcha();
  }
};
</script>
<style scoped>
.captchaInput {
  /* position: absolute; */
  height: 58px;
  width: 40%;
  padding-top: 1.5%;
  /* left: 20%; */
text-decoration: line-through;
  /* background: #fff; */
  border: 1px solid rgba(0, 0, 0, 0.5);
  /* text-shadow: 0px 0px 4px #fff; */
  text-align: center;
  outline: none;
  font-size: 35px;
  /* text-shadow: 4px 2px #d7d4d8; */
  /* color:transparent;
	text-shadow: 2px 4px 6px #fff;

  color: #6E3DEA;
  outline: none;
  font-size: 35px;

  */

  background: url("/img/assets/captcha/rsz_captcha-background-multi4.png");
}

.captchaButton {
  /* additionally, equal width */
  position: absolute;
  height: 58px;
  left: 50%;
  top: 6%;
  top: 10%;
  border: 0px none;
  cursor: pointer;

  /* background: url("/img/assets/captcha/rsz_refresh123.png"); */
}
.captchaButton > a {
  position: relative;
  color: #000000;
  text-decoration: none;
}
.captchaButton > a:hover {
  color: #000000;
}
.captchaButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #000000;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

.captchaButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
@media (max-width: 700px) {
  [class="captchaInput"] {
    /* height: 58px;
    width: 40%;
    left: 20%;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-align: center;
    text-shadow: 4px 2px #d7d4d8;
    transform: translateX(-50%);
    color: #6e3dea;
    outline: none;
    font-size: 25px;
    border: 0px none; */
    /* position:absolute; */
    height: 58px;
    width: 50%;
    padding-top: 1.5%;
    /* left: 20%; */
text-decoration: line-through;
    border: 1px solid rgba(0, 0, 0, 0.5);
    /* text-shadow: 0px 0px 4px #fff; */
    text-align: center;
    outline: none;
    font-size: 25px;
    background: url("/img/assets/captcha/rsz_captcha-background-multi2.png");
  }
}
@media (max-width: 700px) {
  [class="captchaButton"] {
    position: absolute;
    left: 60%;
    top: 6%;
    /* height: 58px; */
    border: 0px none;
    cursor: pointer;
  }
  [class="captchaButton"] > a {
    position: relative;
    color: #000000;
    text-decoration: none;
  }
  [class="captchaButton"] > a:hover {
    color: #000000;
  }
  [class="captchaButton"] > a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0;
    right: 0;
    background-color: #000000;
    visibility: hidden;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.3s ease-in-out 0s;
    transition: all 0.3s ease-in-out 0s;
  }
  [class="captchaButton"] > a:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

/* input[type="button"]:hover {
 background: gray;
} */
/* #btn {
    position: absolute;

  left: 40%;
  top: 67%;
height: 37px;
width: 37px;
 cursor: pointer;
background-image:url('http://www.w3.org/html/logo/downloads/HTML5_Logo_32.png');
background-repeat:no-repeat;
}
#btn:hover{
    background: gray;
} */
</style>